import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=4e973b0f&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=4e973b0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e973b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e973b0f')) {
      api.createRecord('4e973b0f', component.options)
    } else {
      api.reload('4e973b0f', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=4e973b0f&scoped=true&", function () {
      api.rerender('4e973b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/oicd/Login.vue"
export default component.exports